<bom-default-contact *ngIf="shouldShowDefaultContact"></bom-default-contact>
